import { useAxios } from '@/hooks/useAxios';

export const useMixpanelService = () => {
	const { post } = useAxios();
	const logMixpanelEvent = (data: Record<string, any>) =>
		post('/mixpanel/log', data, null);

	return { logMixpanelEvent };
};
